export const PAYMENT_METHODS_PROVIDER_NAMES = {
    ALTERNATE_PAYMENTS: 'alternate_payments',
    DIRECT_PIX: 'direct_pix',
    GCASH: 'gcash',
    PIX: 'pix',
}

export const PAYMENT_CONFIG = {
    [PAYMENT_METHODS_PROVIDER_NAMES.ALTERNATE_PAYMENTS]: {
        icon: 'IcPaymentMethod',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.DIRECT_PIX]: {
        icon: 'IcPix',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.GCASH]: {
        icon: 'IcGcash',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.PIX]: {
        icon: 'IcPix',
    }
};

// TODO CFD-1626 после добавления в transaction payment_key завязаться на это поле
export const MAP_PAYMENT_NAME_TO_ICON = {
    'DIRECT PIX': 'IcPix',
    'Pix': 'IcPix',
    'Alternate Payment Options': 'IcPaymentMethod',
    'Gcash': 'IcGcash',
}
